import { Link } from "gatsby"
import React from "react"

export default () => {
  const categories = [
    {
      title: "Wszystkie",
      slug: "/blog"
    },
    {
      title: "Bez kategorii",
      slug: "/temat/bez-kategorii",
    },
    {
      title: "#sasabox",
      slug: "/temat/sasabox",
    },
    {
      title: "#wolontariat",
      slug: "/temat/wolontariat",
    },
    {
      title: "wydarzenia",
      slug: "/temat/wydarzenia",
    },
    {
      title: "Yemen",
      slug: "/temat/yemen",
    },
  ]
  let pathname = "/blog"
  if (typeof window !== "undefined") {
    pathname = window.location.pathname
  }
  return (
    <nav className="blog-sort margin-bottom40">
      <div className="row">
        <div className="large-8 medium-12 small-12 columns show-for-medium">
          <form id="archive-browser">
            <div className="row">
              <div className="large-1 medium-2 small-4 columns">
                <label className="big" htmlFor="sort2">
                  Temat:
                </label>
              </div>
              <div className="large-5 medium-10 small-8 columns">
                <div className="nice-select wide">
                  <span className="current">{categories.filter((el) => el.slug.includes(pathname))[0]?.title || 'Wszystkie'}</span>
                  <ul className="list" style={{ color: "black!important" }}>
                    {categories.map((category, key) => (
                      <li
                        className={`option ${
                          category.slug.includes(pathname) && "selected"
                        }`}
                        style={{ position: "relative" }}
                        key={key}
                      >
                        {category.title}
                        <Link
                          to={category.slug}
                          style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                          }}
                        ></Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </nav>
  )
}
